import React, { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { enUS } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';

registerLocale('en', enUS);

interface IProps {
  id?: string;
  label?: string;
  name: string;
  value?: string;
  onChange?: (e: any) => void;
  className?: string;
  style?: React.CSSProperties;

  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  maxLength?: number;
  error?: string;

  returnType?: 'YMD' | 'DATE';
  defaultValue?: Date;
  maxDate?: Date;
}

const CustomDate = (props: IProps) => {
  const [inputValue, setInputValue] = useState<Date | null>();
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (props.value) {
      const parsed = dayjs(props.value);
      setInputValue(parsed.isValid() ? parsed.toDate() : null);
    } else {
      setInputValue(null);
    }
  }, [props.value]);

  useEffect(() => {
    if (!props.value && props.defaultValue) {
      handleOnchange(props.defaultValue);
    }
  }, []);

  const handleOnchange = (date: any) => {
    setInputValue(date);

    /*const malaysia = moment(date).tz('Asia/Kuala_Lumpur');

    console.log('date:', date);
    console.log('MY time:', malaysia.format());*/

    const e = {
      target: {
        type: 'datebox',
        value: date,
        name: props.name
      }
    };

    props.onChange?.(e);
  };

  useEffect(() => {
    if (!wrapperRef.current) return;

    let icon;
    let input;
    if ('querySelector' in wrapperRef.current) {
      icon = wrapperRef.current.querySelector<HTMLSpanElement>('.react-datepicker__calendar-icon');
    }
    if ('querySelector' in wrapperRef.current) {
      input = wrapperRef.current.querySelector<HTMLInputElement>(
        '.react-datepicker__input-container input'
      );
    }

    if (icon && input) {
      const clickHandler = () => input.click();
      icon.addEventListener('click', clickHandler);

      return () => {
        icon.removeEventListener('click', clickHandler);
      };
    }
  }, []);

  return (
    <>
      <div className={`custom-date ${props.className || ''}`} style={props.style} ref={wrapperRef}>
        {props.label && <label htmlFor={props.id}>{props.label}</label>}
        <DatePicker
          id={props.id}
          dateFormat={'dd-MMM-yyyy'}
          selected={inputValue}
          onChange={handleOnchange}
          locale={'en'}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          showIcon
          disabled={props.disabled}
          readOnly={props.readOnly}
          maxDate={props.maxDate}
        />
        {props.error && <div className="error-text">{props.error}</div>}
      </div>
    </>
  );
};

export default CustomDate;
